namespace GeniuzPOS.ReportMasterData {
    export interface Report_1308Row {
        Id?: string;
        ShopId?: string;
        ShopName?: string;
        DocDates?: string;
        DocDate?: string;
        GrossSales?: number;
        AllItemDiscount?: number;
        NetSales?: number;
        NetSalesExVat?: number;
        VatOfNetSales?: number;
        AllItemCharge?: number;
        VatOfCharge?: number;
        FullName?: string;
    }

    export namespace Report_1308Row {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'ReportMasterData.Report_1308';
        export const deletePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const insertPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const readPermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';
        export const updatePermission = '1POSBASE:รายงาน:สรุปยอดขาย:รายวัน:แยกร้านค้า:View';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            ShopName = "ShopName",
            DocDates = "DocDates",
            DocDate = "DocDate",
            GrossSales = "GrossSales",
            AllItemDiscount = "AllItemDiscount",
            NetSales = "NetSales",
            NetSalesExVat = "NetSalesExVat",
            VatOfNetSales = "VatOfNetSales",
            AllItemCharge = "AllItemCharge",
            VatOfCharge = "VatOfCharge",
            FullName = "FullName"
        }
    }
}
